/* eslint-disable eqeqeq */
import CompanyView from '../../components/settings/company'
import api from '../../services/service'
import apiCenter from '../../services/service_undefined'

export default {
  data () {
    return {
      confirmDirty: false,
      head_menu: [
        {
          role_id: 1,
          role_name: 'ทั่วไป'
        },
        {
          role_id: 2,
          role_name: 'สิทธิ์'
        }
      ],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0
          },
          sm: {
            span: 16,
            offset: 8
          }
        }
      },
      data_role:{
        role_id:null,
        role_name:null,
        role_code:null
      },
      data_all: [],
      role_code:'',
      role_name:'',
      role_list: []
    }
  },
  components: {
    CompanyView
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'permission' })
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          if (this.data_all.id != undefined)
            values.role_id = parseInt(this.data_all.id)
          values.create_by = this.$store.state.user.username;
          if (values.role_id != undefined) {
           // this.userUpdate(values)
           values.sub_permission = this.data_all.menu_permission
           this.$store.commit('Loading')
            apiCenter.roleUserUpdate({data:values},
              this.header,
              result => {
                this.$store.commit('Loading')
                if(result.data.success) {
                  console.log(result.data)
                  // this.$store.state.historyPage = 'role_menage'
                  this.$router.push({ name: 'role_menage_detail', params: { role_code: values.role_code  } })
                  this.alert_msg("success", "บันทึกข้อมูลสำเร็จ", null);
                } else {
                  this.alert_msg("warning", "บันทึกข้อมูลไม่สำเร็จ เนื่องจากรหัสสิทธิ์ผู้ใช้งานซ้ำ", null);
                }
              },
              error => {
                this.$store.commit('Loading')
                this.alert_msg("warning", "บันทึกข้อมูลไม่สำเร็จ", error.message);

              }
            );
          } else {

            values.sub_permission = this.data_all.menu_permission
            this.$store.commit('Loading')
            apiCenter.roleUserInsert({data:values},
              this.header,
              result => {
                this.$store.commit('Loading')
                if(result.data.success) {
                  console.log(result.data)
                  // this.$store.state.historyPage = 'role_menage'
                  this.$router.push({ name: 'role_menage_detail', params: { role_code: values.role_code } })
                  this.alert_msg("success", "บันทึกข้อมูลสำเร็จ", null);
                } else {
                  // this.alert_msg("warning", "บันทึกข้อมูลไม่สำเร็จ เนื่องจากรหัสสิทธิ์ผู้ใช้งานซ้ำ", null);
                  this.$notification['warning']({
                    message: 'บันทึกข้อมูลไม่สำเร็จ เนื่องจากรหัสสิทธิ์ผู้ใช้งานซ้ำ',
                    description:
                      result.message
                  })
                }
              },
              error => {
                this.$store.commit('Loading')
                this.alert_msg("warning", "บันทึกข้อมูลไม่สำเร็จ", error.message);

              }
            );


           // this.confirmData(values)
          }
        }
      })
    },
    onChange (checked) {
      if (checked == 0) {
        return 1
      }

      if (checked == 1) {
        return 0
      }

    },
    handleConfirmBlur (e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    checkdata () {
      console.log(JSON.stringify(this.data_all))
    },
    UpdateMenuRole () {
      this.$store.commit('Loading')
      api.UpdateMisMenuRole(
        sessionStorage.Url,
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        this.data_all,
        result => {
          this.$store.commit('Loading')
          if (result.response === 'success') {
            location.reload()
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลไม่ได้', result.message)
          }
        },
        error => {
          this.$store.commit('Loading')
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getMenuRole (val) {
      if(this.role_code != null && this.role_code != '')
      {
        apiCenter.roleUserGetCode({role_code:this.role_code},
          this.header,
          result => {
            if(result.data.success) {
              this.data_all = result.data.result[0]
              this.role_code = result.data.result[0].role_code;
              this.role_name = result.data.result[0].role_name;
              this.role_list = result.data.result[0].menu_permission
              this.form.setFieldsValue({role_code: result.data.result[0].role_code, role_name: result.data.result[0].role_name})
            } else {
              this.alert_msg("warning", "ไม่สามารถดึงข้อมูลได้", null);
            }
          },
          error => {
            this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", error.message);
          }
        );
      }else{

        apiCenter.roleUserGet(
          this.header,
          result => {
            if(result.data.success) {
              this.data_role['menu_permission'] = result.data.menu_permission;
              this.data_all = this.data_role;
              this.role_code = '';
              this.role_name = '';
              this.role_list = result.data.menu_permission;
            } else {
              this.alert_msg("warning", "ไม่สามารถดึงข้อมูลได้", null);
            }
          },
          error => {
            this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", error.message);
          }
        );
      }
    },
  },
  mounted () {
    this.role_code = this.$route.params.role_code
    this.getMenuRole(1)
    this.checkUser()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/user_setting.js